module.exports = __webpack_public_path__ + "static/media/dodgem(27).a1ca0ef1.PNG";